/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';
import { func, string } from 'prop-types';
import { useGetAffiliateOptions } from 'hooks';

// Components
import { MDropdown } from 'common';
import { Box, Divider, useMediaQuery } from '@mui/material';
import BolHistory from './BolHistory.connector';
import CarrierPerformance from './CarrierPerformance.connector';

const HistoryPanel = ({ selectedAffiliate, setSelectedAffiliate }) => {
  const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'), { noSsr: true });

  const affiliates = useGetAffiliateOptions(['supplier', 'hasActiveSubscription']);
  const affiliateOptions = [{ label: 'All', value: 'all' }, ...affiliates];

  // if there is only 1 affiliate to view, dropdown is hidden
  return (
    <Box
      sx={{
        backgroundColor: { xs: 'surface.light', md: 'surface.white' },
        mx: 0,
        my: { xs: 0, md: 1 },
        px: { xs: 4, lg: 5 },
        py: { xs: 0, md: '42px' },
      }}
    >
      {mdUp && affiliates.length > 1 && (
        <>
          <MDropdown
            anchorOrigin={{
              horizontal: 'center',
              vertical: 'top',
            }}
            id="affiliate-select"
            items={affiliateOptions}
            label="Affiliate"
            name="affiliate"
            onChange={({ value }) => setSelectedAffiliate(value)}
            value={selectedAffiliate}
          />
          <Divider />
        </>
      )}
      <CarrierPerformance />
      <Divider />
      <BolHistory />
    </Box>
  );
};

HistoryPanel.propTypes = {
  selectedAffiliate: string.isRequired,
  setSelectedAffiliate: func.isRequired,
};

export default HistoryPanel;
